"use client";
// src/components/practice/PracticeViewTracker.tsx
// 未ログインユーザーの閲覧もカウントするための軽量クライアントコンポーネント。
// sessionStorage で同一セッション内の二重カウントを防止する。

import { useEffect } from "react";

export default function PracticeViewTracker({ reportId }: { reportId: string }) {
  useEffect(() => {
    const key = `practice:viewed:${reportId}`;
    try {
      if (sessionStorage.getItem(key) === "1") return;
      sessionStorage.setItem(key, "1");
    } catch {
      // sessionStorage が使えない環境でもカウントは試みる
    }

    fetch(`/api/practice/${reportId}/view`, { method: "POST" }).catch(() => {});
  }, [reportId]);

  return null;
}
